/**
 * Contato público (WhatsApp) — lê do backend /api/public/contact
 * Fallback: 5521998382460
 */

const DEFAULT_NUMBER = '5521998382460';
const CACHE_KEY = 'emperc_whatsapp_number';
const CACHE_TTL_MS = 60 * 60 * 1000;

let memoryCache = { number: null, at: 0 };

function normalizeDigits(value) {
  if (!value) return '';
  let d = String(value).replace(/\D/g, '');
  if (d.length === 10 || d.length === 11) d = `55${d}`;
  return d;
}

export function getCachedWhatsAppNumber() {
  if (memoryCache.number && Date.now() - memoryCache.at < CACHE_TTL_MS) {
    return memoryCache.number;
  }
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (
        parsed?.number &&
        parsed?.at &&
        Date.now() - parsed.at < CACHE_TTL_MS
      ) {
        memoryCache = parsed;
        return parsed.number;
      }
    }
  } catch {
    /* ignore */
  }
  return DEFAULT_NUMBER;
}

function persistNumber(number) {
  const digits = normalizeDigits(number) || DEFAULT_NUMBER;
  memoryCache = { number: digits, at: Date.now() };
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(memoryCache));
  } catch {
    /* ignore */
  }
  return digits;
}

export async function fetchSiteWhatsAppNumber() {
  const base = process.env.REACT_APP_BACKEND_URL || '';
  try {
    const res = await fetch(`${base}/api/public/contact`);
    const json = await res.json().catch(() => null);
    if (res.ok && json?.data?.whatsappNumber) {
      return persistNumber(json.data.whatsappNumber);
    }
  } catch {
    /* fallback */
  }
  return persistNumber(DEFAULT_NUMBER);
}

/** Dispara fetch em background (chamar no boot do app) */
export function prefetchSiteContact() {
  if (typeof window === 'undefined') return;
  void fetchSiteWhatsAppNumber();
}

export default {
  getCachedWhatsAppNumber,
  fetchSiteWhatsAppNumber,
  prefetchSiteContact,
  DEFAULT_NUMBER,
};
